<template>
  <div>
    <b-card>
      <b-card-header>
        <div class="d-flex justify-content-between align-items-center">
          <label>
            Categoria
          </label>
          <b-button-toolbar key-nav aria-label="Toolbar with button groups">
            <b-button-group>
              <Plus class="icon icon-plus" v-b-tooltip.hover :title="'Criar nova categoria'" style="cursor: pointer;" @click="addCategory"/>
            </b-button-group>
          </b-button-toolbar>
        </div>
      </b-card-header>
      <b-card-body>
        <div>
          <b-list-group>
            <b-list-group-item v-for="(category, indexCategory) in categories" :key="category.id">
              <div class="title" :ref="'category-' + indexCategory">
                <strong>
                  <span class="info" v-if="!category.clinic_id">Categoria - (Padrão do sistema)</span>
                  <span class="info" v-else>&nbsp;</span>
                  <b-form-input v-if="category.editable"
                    trim
                    autocomplete="off"
                    placeholder="Descrever"
                    v-model="category.name"
                    @change="updateOrCreateCategory(indexCategory)"
                  />
                  <span v-else>{{ category.name }}</span>
                </strong>
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                  <b-button-group class="mx-1">
                    <Close v-if="editCategoryValue && category.editable && category.name !== ''" class="icon mx-1 icon-close" v-b-tooltip.hover :title="'Cancelar edição'" @click="cancelEditCategory(indexCategory)"/>
                    <Edit  v-if="category.clinic_id" class="icon mx-1 icon-edit" v-b-tooltip.hover :title="'Editar categoria'" @click="editCategory(indexCategory)"/>
                    <Trash v-if="category.clinic_id" class="icon mx-1 icon-trash" v-b-tooltip.hover :title="'Remover categoria'" @click="removeCategory(indexCategory)"/>
                    <toggle-button 
                      class="toggle-button mx-1" 
                      :color="{checked: '#00C773', unchecked: '#E1E5F4'}"
                      @change="(value) => handleToggleCategory(value, indexCategory)" 
                      :value="!!(category.status.enable)"
                      v-model="category.status.enable"
                    />
                    <div class="chevron" v-b-toggle="'collapseClasse' + category.id">
                        <ChevronDown class="icon down" />
                        <ChevronUp class="icon up" />
                    </div>
                  </b-button-group>
                </b-button-toolbar>
              </div>
              <b-collapse :visible="category.status.isVisible" :id="'collapseClasse' + category.id" class="mt-2">
                <b-card>
                  <b-card-header>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        Classes
                      </label>
                      <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                        <b-button-group>
                          <Plus class="icon icon-plus" v-b-tooltip.hover :title="'Criar nova classe'" @click="addClass(indexCategory)"/>
                        </b-button-group>
                      </b-button-toolbar>
                    </div>
                  </b-card-header>
                  <b-card-body>
                    <b-list-group>
                      <b-list-group-item v-for="(classe, indexClass) in category.classes" :key="classe.id">
                        <div class="title" :ref="'class-' + indexClass">
                          <strong>
                            <span class="info" v-if="!classe.clinic_id">Classe - (Padrão do sistema)</span>
                            <span class="info" v-else>&nbsp;</span>
                            <b-form-input v-if="classe.editable"
                              trim
                              autocomplete="off"
                              placeholder="Descrever"
                              @change="updateOrCreateClass(indexCategory, indexClass)"
                              v-model="classe.name"
                            />
                            <span v-else>{{ classe.name }}</span>
                          </strong>
                          <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group>
                              <Close v-if="editClassValue && classe.editable && classe.name !== ''" class="icon mx-1 icon-close" v-b-tooltip.hover :title="'Cancelar edição'" @click="cancelEditClass(indexCategory, indexClass)"/>
                              <Edit  v-if="classe.clinic_id" class="icon mx-1 icon-edit" v-b-tooltip.hover :title="'Editar classe'" @click="editClass(indexCategory, indexClass)"/>
                              <Trash v-if="classe.clinic_id" class="icon mx-1 icon-trash" v-b-tooltip.hover :title="'Remover classe'" @click="removeClass(indexCategory, indexClass)"/>
                              <toggle-button 
                                class="toggle-button mx-1" 
                                :color="{checked: '#00C773', unchecked: '#E1E5F4'}"
                                @change="(value) => handleToggleClass(value, indexCategory, indexClass)" 
                                :value="!!(classe.status.enable)"
                                v-model="classe.status.enable"
                              />
                              <div class="chevron" v-b-toggle="'collapseSubclasse' + classe.id">
                                  <ChevronDown class="icon down" />
                                  <ChevronUp class="icon up" />
                              </div>
                            </b-button-group>
                          </b-button-toolbar>
                        </div>
                        <b-collapse :visible="classe.status.isVisible" :id="'collapseSubclasse' + classe.id" class="mt-2">
                          <b-card>
                            <b-card-header>
                              <div class="d-flex justify-content-between align-items-center">
                                <label>
                                  Subclasses
                                </label>
                                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                                  <b-button-group>
                                    <Plus class="icon icon-plus" v-b-tooltip.hover :title="'Criar nova subclasse'" @click="addSubclass(indexCategory, indexClass)"/>
                                  </b-button-group>
                                </b-button-toolbar>
                              </div>
                            </b-card-header>
                            <b-card-body>
                              <b-list-group>
                                <b-list-group-item v-for="(subclasse, indexSubclass) in classe.subclasses" :key="subclasse.id">
                                  <div class="title" :ref="'subclass-' + indexSubclass">
                                    <span class="info" v-if="!subclasse.clinic_id">Subclasse - (Padrão do sistema)</span>
                                    <span class="info" v-else>&nbsp;</span>
                                    <b-form-input v-if="subclasse.editable"
                                      trim
                                      autocomplete="off"
                                      placeholder="Descrever"
                                      v-model="subclasse.name"
                                      @change="updateOrCreateSubclass(indexCategory, indexClass, indexSubclass)"
                                    />
                                    <span class="w-100" v-else>{{ subclasse.name }}</span>
                                    <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                                      <b-button-group>
                                        <Close v-if="editSubClasseValue && subclasse.editable && subclasse.name !== ''" class="icon mx-1 icon-close" v-b-tooltip.hover :title="'Cancelar edição'" @click="cancelEditSubclass(indexCategory, indexClass, indexSubclass)"/>
                                        <Edit  v-if="subclasse.clinic_id" class="icon mx-1 icon-edit" v-b-tooltip.hover :title="'Editar subclasse'" @click="editSubclass(indexCategory, indexClass, indexSubclass)"/>
                                        <Trash v-if="subclasse.clinic_id" class="icon mx-1 icon-trash" v-b-tooltip.hover :title="'Remover subclasse'" @click="removeSubclass(indexCategory, indexClass, indexSubclass)"/>
                                        <toggle-button 
                                          class="toggle-button mx-1" 
                                          :color="{checked: '#00C773', unchecked: '#E1E5F4'}"
                                          @change="(value) => handleToggleSubclass(value, indexCategory, indexClass, indexSubclass)" 
                                          :value="!!(subclasse.status.enable)"
                                          v-model="subclasse.status.enable"
                                        />
                                        <div class="chevron" v-b-toggle="'collapseSubclasse' + classe.id">
                                            <ChevronDown class="icon down" />
                                            <ChevronUp class="icon up" />
                                        </div>
                                      </b-button-group>
                                    </b-button-toolbar>
                                  </div>
                                </b-list-group-item>
                              </b-list-group>
                            </b-card-body>
                          </b-card>
                        </b-collapse>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card-body>
                </b-card>
              </b-collapse>
            </b-list-group-item>  
          </b-list-group>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { userHasPermission, getCurrentClinic } from '@/utils/localStorageManager'

export default {
  components: {
    ChevronDown: () => import('@/assets/icons/chevron-down-select.svg'),
    ChevronUp: () => import('@/assets/icons/chevron-up.svg'),
    Plus: () => import('@/assets/icons/icon-plus.svg'),
    Edit: () => import('@/assets/icons/edit.svg'),
    Trash: () => import('@/assets/icons/trash.svg'),
    Close: () => import('@/assets/icons/close.svg')
  },
  mounted() {
    this.getCategories()    
  },
  data() {
    return {
      canEditModule: userHasPermission('EstConf2'),
      canEditPreferences: userHasPermission('EstConf3'),
      clinic: getCurrentClinic(),
      categories: [],
      editCategoryValue: false,
      editClassValue: false,
      editSubClasseValue: false,
    };
  },
  methods: {
    getCategories() {
      const isLoading = this.$loading.show();
      this.api.getWarehouseProductCategories(this.clinic.id)
      .then(res => {        
        this.categories = res.data;
      })
      .catch(err => this.$toast.error(err.message))
      .finally(() => isLoading.hide());
    },
    addCategory() {
      this.categories.push({
        id: 'new_category_'+Date.now(),
        editable: true,
        name: '',
        clinic_id: this.clinic.id,
        status: {
          enable: true,
          isVisible: true
        },
        classes: [
          {
            id: 'new_class_'+Date.now(),
            clinic_id: this.clinic.id,
            editable: true,
            name: '',
            status: {
              enable: true,
              isVisible: true
            },
            subclasses: []
          }
        ]
      });

      this.$nextTick(() => {
        const categories = this.categories;
        const lastIndex = categories.length - 1;
        const lastRef = this.$refs['category-' + lastIndex];

        const element = Array.isArray(lastRef) ? lastRef[0] : lastRef;

        if (element && typeof element.scrollIntoView === 'function') {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    addClass(indexCategory) {
      this.categories[indexCategory].classes.push({
          id: 'new_class_'+Date.now(),
          clinic_id: this.clinic.id,
          editable: true,
          name: '',
          status: {
            enable: true
          },
          subclasses: []
      });

      this.$nextTick(() => {
        const classes = this.categories[indexCategory].classes;
        const lastIndex = classes.length - 1;
        const lastRef = this.$refs['class-' + lastIndex];

        const element = Array.isArray(lastRef) ? lastRef[this.categories[indexCategory].classes.length - 1] : lastRef;

        if (element && typeof element.scrollIntoView === 'function') {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      
    },
    addSubclass(indexCategory, indexClass) {
      this.categories[indexCategory].classes[indexClass].subclasses.push({
        id: 'new_subclass_'+Date.now(),
        clinic_id: this.clinic.id,
        editable: true,
        name: '',
        status: {
          enable: true
        },
      });

      this.$nextTick(() => {
        const subclasses = this.categories[indexCategory].classes[indexClass].subclasses;
        const lastIndex = subclasses.length - 1;
        const lastRef = this.$refs['subclass-' + lastIndex];

        const element = Array.isArray(lastRef) ? lastRef[0] : lastRef;

        if (element && typeof element.scrollIntoView === 'function') {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    editCategory(index) {
      this.editCategoryValue = true
      this.$set(this.categories[index], 'editable', true);
    },
    cancelEditCategory(index) {
      this.editCategoryValue = false
      this.$set(this.categories[index], 'editable', false);
    },
    editClass(indexCategory, index) {
      this.editClassValue = true
      this.$set(this.categories[indexCategory].classes[index], 'editable', true);
    },
    cancelEditClass(indexCategory, index) {
      this.editClassValue = false
      this.$set(this.categories[indexCategory].classes[index], 'editable', false);
    },
    editSubclass(indexCategory, indexClass, index) {
      this.editSubClassValue = true
      this.$set(this.categories[indexCategory].classes[indexClass].subclasses[index], 'editable', true);
    },
    cancelEditSubclass(indexCategory, indexClass, index) {
      this.editSubClassValue = false
      this.$set(this.categories[indexCategory].classes[indexClass].subclasses[index], 'editable', false);
    },
    async updateOrCreateCategory(index) {
      if(!this.categories[index].classes[0].name){
        this.$toast.warning('A categoria deve ter pelo menos uma classe associada para ser salva.');
        this.categories[index].saveWithClass = true;
      } else {
        this.categories[index].editable = false;

        if(this.categories[index].id.includes("new_category_")){
          await this.api.addWarehouseProductCategory({
            name: this.categories[index].name,
            clinic_id: this.clinic.id
          }).then(res => {
            this.categories[index].id = res.data.id;
          });
        } else {
          await this.api.updateWarehouseProductCategory(this.categories[index].id, {
            name: this.categories[index].name
          });
        }

        if(this.categories[index].classes[0].name && !this.categories[index].classes[0].id.includes("new_class_")){
          this.updateOrCreateClass(index, 0);
        }
      }
    },
    async updateOrCreateClass(indexCategory, index) {
      
      if(this.categories[indexCategory].saveWithClass){
        await this.updateOrCreateCategory(indexCategory);
        this.categories[indexCategory].saveWithClass = false;
      }

      if(!this.categories[indexCategory].name){
        this.$toast.error('É necessário informar o nome da categoria. Não é possível cadastrar uma classe sem uma categoria.');
        return false;
      }

      this.categories[indexCategory].classes[index].editable = false;
      
      if(this.categories[indexCategory].classes[index].id.includes("new_class_")){
        this.api.addWarehouseProductClass({
          product_category_id: this.categories[indexCategory].id,
          name: this.categories[indexCategory].classes[index].name,
          clinic_id: this.clinic.id
        }).then(res => {
          this.categories[indexCategory].classes[index].id = res.data.id;
        });
      } else {
        this.api.updateWarehouseProductClass(this.categories[indexCategory].classes[index].id, {
          name: this.categories[indexCategory].classes[index].name,
        });
      }
    },
    updateOrCreateSubclass(indexCategory, indexClass, index) {
      if(!this.categories[indexCategory].classes[indexClass].name){
        this.$toast.error('É necessário informar o nome da classes. Não é possível cadastrar uma subclasses sem uma classes.');
        return 
      }
      this.categories[indexCategory].classes[indexClass].subclasses[index].editable = false;

      if(this.categories[indexCategory].classes[indexClass].subclasses[index].id.includes("new_subclass_")){
        this.api.addWarehouseProductSubclass({
          product_class_id: this.categories[indexCategory].classes[indexClass].id,
          name: this.categories[indexCategory].classes[indexClass].subclasses[index].name,
          clinic_id: this.clinic.id
        });
      } else {
        this.api.updateWarehouseProductSubclass(this.categories[indexCategory].classes[indexClass].subclasses[index].id, {
          name: this.categories[indexCategory].classes[indexClass].subclasses[index].name,
        });
      }
    },
    removeCategory(index) {
      if(this.categories[index].id.includes("new_category_")) {
        this.categories.splice(index, 1);
        return
      }
      this.$swal({
        title: 'Aviso',
        html: `Essa ação é irreversível. Deseja realmente excluir este cadastro?`,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
        }).then(async res => {
        if (res.isConfirmed) {
          this.api.deleteWarehouseProductCategory(this.categories[index].id)
          .then(res => {
            this.categories.splice(index, 1);
          })
          .catch(err => {
            this.$toast.error(err.response.data.message)
          });
        }
      });
    },
    removeClass(indexCategory, index) {
      if(this.categories[indexCategory].classes[index].id.includes("new_class")) {
        this.categories[indexCategory].classes.splice(index, 1);
        return
      }
      this.$swal({
        title: 'Aviso',
        html: `Essa ação é irreversível. Deseja realmente excluir este cadastro?`,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
        }).then(async res => {
          if (res.isConfirmed) {
            this.api.deleteWarehouseProductClass(this.categories[indexCategory].classes[index].id)
            .then(res => {
              this.categories[indexCategory].classes.splice(index, 1);
            })
            .catch(err => {
              console.log(err);
              this.$toast.error(err.response.data.message)
            });
          }
        });
    },
    removeSubclass(indexCategory, indexClass, index) {
      if(this.categories[indexCategory].classes[indexClass].id.includes("new_class_")) {
        this.categories[indexCategory].classes[indexClass].subclasses.splice(index, 1);
        return
      }
      this.$swal({
        title: 'Aviso',
        html: `Essa ação é irreversível. Deseja realmente excluir este cadastro?`,
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
        }).then(async res => {
        if (res.isConfirmed) {
          this.api.deleteWarehouseProductSubclass(this.categories[indexCategory].classes[indexClass].subclasses[index].id)
          .then(res => {
            this.categories[indexCategory].classes[indexClass].subclasses.splice(index, 1);
          })
          .catch(err => {
            this.$toast.error(err.response.data.message)
          });
        }
      });
    },
    handleToggleCategory(value, index) {
      if(value.value){
        this.api.enableWarehouseProductCategory(this.clinic.id, this.categories[index].id).then(res => {
          this.$toast.success("Cadastro habilitado com sucesso!");
        });
      } else {
        this.api.disableWarehouseProductCategory(this.clinic.id, this.categories[index].id).then(res => {
          this.$toast.success("Cadastro desabilitado com sucesso!");
        });        
      }
      this.categories[index].status = value;
    },
    handleToggleClass(value, indexCategory, index) {
      if(value.value){
        this.api.enableWarehouseProductClass(this.clinic.id, this.categories[indexCategory].classes[index].id).then(res => {
          this.$toast.success("Cadastro habilitado com sucesso!");
        });
      } else {
        this.api.disableWarehouseProductClass(this.clinic.id, this.categories[indexCategory].classes[index].id).then(res => {
          this.$toast.success("Cadastro desabilitado com sucesso!");
        });        
      }
      this.categories[indexCategory].classes[index].status = value;
    },
    handleToggleSubclass(value, indexCategory, indexClass, index) {
      if(value.value){
        this.api.enableWarehouseProductSubclass(this.clinic.id, this.categories[indexCategory].classes[indexClass].subclasses[index].id).then(res => {
          this.$toast.success("Cadastro habilitado com sucesso!");
        });
      } else {
        this.api.disableWarehouseProductSubclass(this.clinic.id, this.categories[indexCategory].classes[indexClass].subclasses[index].id).then(res => {
          this.$toast.success("Cadastro desabilitado com sucesso!");
        });        
      }
      this.categories[indexCategory].classes[indexClass].subclasses[index].status = value;
    }
  },
}
</script>
<style lang="scss" scoped>
.card {

  .card {
    margin: 0px 20px 20px 20px;
    .card {
      margin: 0px 20px 20px 20px;
    }
  }

  .card-header {
    padding: auto;
    color: #0C1D59;
    font-size: 16px;
    font-weight: 600;
    height: 56px;

  }

  .title {
    padding: 10px;
    color: #0C1D59;
    font-size: 16px;
    display: inline-flex;
    width: 100%;

    strong {
      width: inherit;
    }
    
    .info {
      font-size: 12px;
      font-weight: 600;
      line-height: 15.6px;
      text-align: left;
      color: #8696AC;
      display: block;
    }
  }
  
  .card-body {
    padding: 0px;
  }

  .list-group-item {
    padding: 0px;
  }

  .btn-toolbar {
    float: right;
    margin-top: auto;

    .icon {
      width: 25px;
      height: 25px;
    }

    .icon-trash {
      path {
        stroke: #FBA59D;
      }
    }

    .v-switch-core{
      width: 40px !important;
    }

    .collapsed {
      .down {
        display: block;
      }
      .up {
        display: none;
      }
    }

    .not-collapsed {
      .down {
        display: none;
      }
      .up {
        display: block;
      }
    }
  }
}
</style>